import React from 'react';
import cx from 'classnames';
import DropDownMenu from './dropDownMenu';
import NaviBarStore, { NAVTYPE } from './store';
import wrapStore from '@src/utils/wrap-store';
import Link from '@src/components/link';
import BGM from '@src/business-components/bgm';
import LanguageSelect from '../common-language-select';
import FollowUs from '@src/business-components/common-follow-us';
import getPageLocalesData from '@src/global-locales/get-page-locales-data';
import { getLocales } from '@src/global-locales/get-page-locales-data';
import { $$tracker } from '@src/tracker';

const styles = require('./index.less');

/**
 * NaviBar
 * @param className
 * @param store {NaviBarStore}
 * @returns {JSX.Element}
 * @constructor
 */
const NaviBar = ({ className, store }) => {
  store.use();
  const { navList, dropDownMenuStore, $globalStore } = store;
  const pageLocalesData = getPageLocalesData();
  const navbarData = pageLocalesData.navbar;
  const commonData = pageLocalesData.common;

  /**
   * 渲染登录模块
   */
  const renderLoginPart = () => {
    if ($globalStore.accountInfo) {
      return (
        <div className={styles.navList}>
          <div className={cx(styles.navBtn)}>
            <div className={styles.navTitle}>
              {$globalStore.accountInfo}
              <span className={styles.dropDownIcon} />
            </div>
            <div className={styles.menuWrap}>
              <div className={styles.dropDownMenu}>
                <div className={styles.menuItem} onClick={store.exitAccount}>
                  {commonData.exit_content}
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div
        className={styles.loginBtn}
        onClick={() => {
          $$tracker.clickMainNaviBarLogin();
          store.login();
        }}
      >
        {$globalStore.isDownloadStage ? commonData.login_content : getLocales('reserve.button')}
      </div>
    );
  };
  /**
   * 渲染分享模块
   */
  const renderSharePart = () => {
    return (
      <div className={styles.sharePart}>
        <div className={styles.shareIcon} />
        <div className={styles.shareMenu}>
          <Link
            className={cx(styles.shareMenuItem, styles.bilibili)}
            href={'https://space.bilibili.com/3493282537540091?spm_id_from=333.1007.0.0'}
            target={'_blank'}
          />
          <div className={cx(styles.shareMenuItem, styles.wechat, styles.expandQr)}>
            <div className={cx(styles.qrBox, styles.wechat)} />
          </div>
          <Link
            className={cx(styles.shareMenuItem, styles.qq)}
            href={
              'https://qm.qq.com/cgi-bin/qm/qr?_wv=1027&k=gbuzypsuPnluscrHbJnSm3eaASqpBQqw&authKey=cFyhCCMSU2FJCYzipcoN%2F4fDkS%2F86xAT%2F9lFDQ1ACWfuU09aO4qgGUVDslepnz8u&noverify=0&group_code=663718387'
            }
            target={'_blank'}
          />
          <Link className={cx(styles.shareMenuItem, styles.weibo)} href={'https://weibo.com/u/7733721279'} target={'_blank'} />
          <Link
            className={cx(styles.shareMenuItem, styles.xhs)}
            href={
              'https://www.xiaohongshu.com/user/profile/67526aaf000000001d02cc5d?xsec_token=AB7tgXqhObA3WGPvojS-bbuJXbUKneJFN4ucrFOmqkNJ0=&xsec_source=pc_search'
            }
            target={'_blank'}
          />
          <Link className={cx(styles.shareMenuItem, styles.copyLink)} onClick={store.onCopyLink} />
        </div>
      </div>
    );
  };
  /**
   * 渲染背景音乐模块
   */
  const renderMusicPart = () => {
    return (
      <div className={styles.musicPart}>
        <BGM onClick={() => $$tracker.clickMainNaviBarMusic()} store={store.bgm} className={styles.musicBtn} />
      </div>
    );
  };

  return (
    <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', zIndex: 200 }}>
      <div className={cx(styles.navRoot, className, store.isSticky && styles.sticky)}>
        <DropDownMenu store={dropDownMenuStore} isSticky={store.isSticky} />
        <div className={cx(styles.navbarMain, !dropDownMenuStore.isExpand && styles.active)}>
          <div className={styles.nbLeftGroup} onMouseOver={() => dropDownMenuStore.onLogoMenuHover()}>
            <img className={styles.seasunLogo} alt="西山居" src={require('./images/normal-seasun-logo.png')} />
            <div className={styles.dropDownIcon} />
          </div>
          <div className={styles.nbRightGroup}>
            <div className={styles.groupLeft}>
              <Link className={styles.logo} />
              <div className={styles.navList}>
                {navList.map((item, index) => {
                  return <NavSwitch key={index} data={item} store={store} />;
                })}
              </div>
            </div>
            <div className={styles.groupRight}>
              {<div className={styles.loginContainer}>{renderLoginPart()}</div>}
              {/*<div className={styles.shareContainer}>{renderSharePart()}</div>*/}
              <div className={styles.musicContainer}>{renderMusicPart()}</div>
              <div className={styles.followUs}>
                <FollowUs store={store.followUsStore} />
              </div>
              <div className={styles.changeLanguageBtn}>
                <LanguageSelect buttonDisplay={'nav'} />
              </div>
              {$globalStore.isDownloadStage && (
                <Link onClick={store.toDownloadPage} className={styles.btnDownload}>
                  {getLocales('navbar.download')}
                </Link>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

//#region 状态条展示逻辑
const isActiveHref = link => {
  return window.location.href.indexOf(link) > -1;
};
const isActiveLink = link => {
  let path = IS_DEV_ENV ? window.location.hash.slice(1).split('?')[0] : window.location.pathname.replace('.html', '');
  let pathList = [];
  pathList = path.split('/').filter(Boolean);
  // 首页的情况
  if (!link) {
    return !pathList.length || pathList.pop() === 'index';
  }
  return pathList.includes(link);
};
const isActiveSelect = childs => {
  return childs.some(i => (i.isHref ? isActiveHref(i.link) : isActiveLink(i.link)));
};
//#endregion 状态条展示逻辑

const NavSwitch = ({ data, store }) => {
  const { childs = [], title = '', link = '/', isHref = false, toast } = data;
  const RenderAnchorNav = () => {
    return (
      <div className={styles.navBtn}>
        <div className={styles.navTitle}>{title}</div>
      </div>
    );
  };

  const RenderLinkNav = () => {
    return (
      <div
        className={cx(styles.navBtn, { [styles.active]: isHref ? isActiveHref(link) : isActiveLink(link) })}
        onClick={() => {
          data.tracker?.();
          store.toPage(link, isHref, toast);
        }}
      >
        <div className={styles.navTitle}>{title}</div>
      </div>
    );
  };

  const RenderSelectNav = () => {
    return (
      <div className={cx(styles.navBtn, { [styles.active]: isActiveSelect(childs) })}>
        <div className={styles.navTitle}>
          {title}
          <span className={styles.dropDownIcon} />
        </div>
        <div className={styles.menuWrap}>
          <div className={styles.dropDownMenu}>
            {childs.map(({ title, link, isHref, tracker, onClick, toast }, index) => {
              return (
                <div
                  key={index}
                  className={styles.menuItem}
                  onClick={() => {
                    tracker?.();
                    if (onClick) {
                      onClick();
                      return;
                    }
                    store.toPage(link, isHref, toast);
                  }}
                >
                  {title}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  };

  switch (data.type) {
    case NAVTYPE.ANCHOR:
      return <RenderAnchorNav data={data} />;
    case NAVTYPE.Link:
      return <RenderLinkNav data={data} />;
    case NAVTYPE.SELECT:
      return <RenderSelectNav data={data} />;
    default:
      break;
  }
};

export default wrapStore(NaviBar, NaviBarStore);
